import { gql } from '@apollo/client'

export const UPDATE_COLOR = gql`
  mutation updateColor($input: UpdateColorInput!) {
    data: updateColor(input: $input) {
      id
    }
  }
`
